/*
 *
 * SignInPage
 *
 */

import H1 from "components/H1";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getSearchParam } from "utils/helpers";
import SignInForm from "./Form";
import { Heading, Wrapper } from "./styledComponents";

const SignInPage = () => {
  // `location` used to arrive as a prop from <Route render={props => ...}>.
  // react-router v7 renders `element` and injects nothing, so read it from the
  // hook instead — otherwise `search` is undefined and the page throws.
  const { search } = useLocation();
  const email = getSearchParam(search, "email");
  return (
    <Wrapper>
      <HelmetProvider>
        <Helmet title="Movebooth | Sign In" />
      </HelmetProvider>
      <Heading>
        <H1>👋 Welcome back.</H1>
        <p className="pt-4 ">
          Please enter your Movebooth login details to sign in and start making
          some serious moves.
        </p>
      </Heading>
      <SignInForm initialValues={{ email }} />
    </Wrapper>
  );
};

export default SignInPage;
